/**
 * Shared LLM-tier → model mapping for the Agent Builder.
 *
 * Single source of truth used by BOTH the Build Inspector (to show which model a
 * selected tier resolves to) and the "Generate Python" codegen (kernel TIER_MODELS).
 * Mirrors the platform's severity-based tier routing.
 */

import type { LlmTier } from '../../types/agentBuilder';

/** Tier → concrete model id (what actually runs / is emitted into generated code). */
export const TIER_MODEL: Record<LlmTier, string> = {
  premium: 'claude-opus-4-8',
  mid: 'claude-sonnet-4-6',
  cost: 'claude-haiku-4-5',
};

/** Tier → human-friendly model name (for display in the Inspector). */
export const TIER_LABEL: Record<LlmTier, string> = {
  premium: 'Claude Opus 4.8',
  mid: 'Claude Sonnet 4.6',
  cost: 'Claude Haiku 4.5',
};
